import React from "react";
import { Link } from "react-router-dom";

import "./Link.css";

const Linker = (props) => {
  return (
    <Link to={props.to} className="link" style={props.styles}>
      {props.children}
    </Link>
  );
};

export default Linker;
